const TOPICS = [
  "Science",
  "Politics",
  "Philosophy",
  "Religion",
  "Media & Gatekeeping",
  "National · Party Politics",
  "Georgia · State Policy",
  "Local · Henry County / District 5",
  "Data Centers",
  "Other",
];

const inputCls =
  "w-full bg-white border border-slate-300 focus:border-[var(--accent)] text-[#0A192F] placeholder-slate-400 px-4 py-3 text-sm outline-none transition-colors";
const labelCls = "text-xs tracking-tight text-slate-500 mb-2 block";

const QuestionField = ({ form, guest, setField, toggleField }) => (
  <div>
    <label htmlFor="atfq-question" className={labelCls}>
      Your Question <span className="text-[var(--accent)]">*</span>
    </label>
    <textarea
      id="atfq-question"
      data-testid="atfq-ask-question"
      required
      minLength={5}
      maxLength={2000}
      rows={5}
      value={form.question}
      onChange={setField("question")}
      placeholder={
        guest
          ? `What should Vic put to ${guest.name.split(" ")[0]} on the record?`
          : "What do you want ATFQ to answer, unfiltered?"
      }
      className={`${inputCls} resize-y`}
    />
  </div>
);

const TopicAndNameFields = ({ form, guest, setField, toggleField }) => (
  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
    <div>
      <label htmlFor="atfq-topic" className={labelCls}>
        Topic
      </label>
      <select
        id="atfq-topic"
        data-testid="atfq-ask-topic"
        value={form.topic}
        onChange={setField("topic")}
        className={inputCls}
      >
        {TOPICS.map((t) => (
          <option key={t} value={t}>
            {t}
          </option>
        ))}
      </select>
    </div>
    <div>
      <label htmlFor="atfq-name" className={labelCls}>
        Name <span className="text-slate-400">(optional)</span>
      </label>
      <input
        id="atfq-name"
        data-testid="atfq-ask-name"
        type="text"
        maxLength={120}
        value={form.submitter_name}
        onChange={setField("submitter_name")}
        placeholder="Anonymous is fine"
        className={inputCls}
      />
    </div>
  </div>
);

const EmailField = ({ form, guest, setField, toggleField }) => (
  <div>
    <label htmlFor="atfq-email" className={labelCls}>
      Email <span className="text-slate-400">(optional — only if you want a reply)</span>
    </label>
    <input
      id="atfq-email"
      data-testid="atfq-ask-email"
      type="email"
      maxLength={200}
      value={form.submitter_email}
      onChange={setField("submitter_email")}
      placeholder="you@example.com"
      className={inputCls}
    />
  </div>
);

const ConsentField = ({ form, guest, setField, toggleField }) => (
  <label className="flex items-start gap-3 cursor-pointer group">
    <input
      type="checkbox"
      data-testid="atfq-ask-public-consent"
      checked={form.is_public_allowed}
      onChange={toggleField("is_public_allowed")}
      className="mt-1 w-4 h-4 accent-[var(--accent)] shrink-0"
    />
    <span className="text-sm text-slate-700 leading-relaxed">
      You can read my question{" "}
      <span className="text-[#0A192F] font-medium">on-air</span> — name
      stays anonymous unless I say otherwise.
    </span>
  </label>
);

export const AskFields = (props) => (
  <>
    <QuestionField {...props} />
    <TopicAndNameFields {...props} />
    <EmailField {...props} />
    <ConsentField {...props} />
  </>
);

export default AskFields;
